import { DiscountType } from '@trnsact/trnsact-shared-types';

import { Charge } from '../types';

class ChargeCalc {
  private toPercent(amount: number) {
    return amount / 100;
  }

  public calcRetailPrice(charge: Charge) {
    const {
      price: { wholesalePrice, markup, markupType },
    } = charge;

    if (markupType === DiscountType.Flat) return wholesalePrice + markup;
    if (markupType === DiscountType.Percent) return wholesalePrice + wholesalePrice * this.toPercent(markup);

    throw new Error('Unrecognized value for charge.');
  }

  public calcNetPrice(charge: Charge) {
    const retailPrice = this.calcRetailPrice(charge);

    const {
      price: { discount, discountType },
    } = charge;

    if (discountType === DiscountType.Flat) return retailPrice - discount;
    if (discountType === DiscountType.Percent) return retailPrice - retailPrice * this.toPercent(discount);

    throw new Error('Unrecognized value for charge.');
  }

  public calcChargeTotal(charge: Charge) {
    const netPrice = this.calcNetPrice(charge);

    const {
      price: { salesTax, salesTaxType },
    } = charge;

    if (salesTaxType === DiscountType.Flat) return netPrice - salesTax;
    if (salesTaxType === DiscountType.Percent) return netPrice + netPrice * this.toPercent(salesTax);

    throw new Error('Unrecognized value for charge.');
  }
}

export const chargeCalc = new ChargeCalc();
